import {Avatar, Space, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Title} = Typography;

const TeamFotoUlt = (datos) => {
  return (
    <Space align="center" direction="vertical" size="middle" style={{display: 'flex', textAlign: 'center', maxWidth: '300px'}}>
      <Avatar size={100} src={datos.foto} />
      <Title level={3} style={{color: appColors['ColorAz'], textAlign: 'center'}}>{datos.nombre}</Title>
      <Title level={4} style={{color: 'black', textAlign: 'center'}}>{datos.puesto}</Title>
    </Space>
  );
};

export default TeamFotoUlt;
